import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import AgentList from './components/AgentList';
import Pricing from './components/Pricing';
import WhitePaper from './components/WhitePaper';
import Auth from './components/Auth';
import AuthCallback from './components/AuthCallback';
import Welcome from './components/Welcome';
import PaymentSuccess from './components/PaymentSuccess';
import Subscribe from './components/Subscribe';
import { AuthProvider } from './contexts/AuthContext';
import { Analytics } from "@vercel/analytics/react"

function App() {
    return (
        <AuthProvider>
            <div className="App">
                <Navigation />
                <main>
                    <Routes>
                        <Route path="/" element={
                            <>
                                <Hero />
                                <AgentList />
                            </>
                        } />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/subscribe" element={<Subscribe />} />
                        <Route path="/signup" element={<Auth />} />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route path="/welcome" element={<Welcome />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/donation/success" element={<PaymentSuccess />} />
                        <Route path="/whitepaper" element={<WhitePaper />} />
                    </Routes>
                </main>
                <footer className="py-3 mt-4 bg-dark text-white text-center">
                    <p>&copy; 2026 Agenti. All rights reserved.</p>
                    <p>
                        made by <a href="https://x.com/shanni_talks" className="text-white" target="_blank" rel="noopener noreferrer">@shanni_talks</a>
                    </p>
                </footer>
                <Analytics />
            </div>
        </AuthProvider>
    );
}

export default App;
